import { appApiEndpoint } from "@/environment";
import { baseApi } from "./baseApi";

// Person Lists API slice - extends the base API
export const personListsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get paginated person lists
    getPersonLists: builder.query({
      query: ({
        employerPermalink,
        perPage = 50,
        cursor = null,
        searchQuery = null,
        isPrefetchQuery = false,
      }) => {
        let url = new URL(
          `${appApiEndpoint}/v1/employers/${employerPermalink}/person-lists`
        );
        let params = new URLSearchParams();
        params.append("perPage", perPage);

        if (cursor) {
          params.append("cursor", cursor);
        }
        if (searchQuery) {
          params.append("search", searchQuery);
        }

        url.search = params.toString();
        return { url: url.toString(), method: "GET", isPrefetchQuery };
      },
      providesTags: ["PersonLists"],
    }),

    // Get single person list
    getPersonList: builder.query({
      query: ({ employerPermalink, personListPermalink }) => ({
        url: `${appApiEndpoint}/v1/employers/${employerPermalink}/person-lists/${personListPermalink}`,
        method: "GET",
      }),
      providesTags: (result, error, { personListPermalink }) => [
        { type: "PersonLists", id: personListPermalink },
      ],
    }),

    // Create person list
    createPersonList: builder.mutation({
      query: ({ employerPermalink, personListData }) => ({
        url: `${appApiEndpoint}/v1/employers/${employerPermalink}/person-lists`,
        method: "POST",
        data: personListData,
      }),
      invalidatesTags: ["PersonLists"],
    }),

    // Update person list
    updatePersonList: builder.mutation({
      query: ({ employerPermalink, personListPermalink, personListData }) => ({
        url: `${appApiEndpoint}/v1/employers/${employerPermalink}/person-lists/${personListPermalink}`,
        method: "PUT",
        data: personListData,
      }),
      invalidatesTags: (result, error, { personListPermalink }) => [
        { type: "PersonLists", id: personListPermalink },
        "PersonLists",
      ],
    }),

    // Delete person list
    deletePersonList: builder.mutation({
      query: ({ employerPermalink, personListPermalink }) => ({
        url: `${appApiEndpoint}/v1/employers/${employerPermalink}/person-lists/${personListPermalink}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { personListPermalink }) => [
        { type: "PersonLists", id: personListPermalink },
        "PersonLists",
      ],
    }),
  }),
});

// Export hooks for usage in components
export const {
  useGetPersonListsQuery,
  useGetPersonListQuery,
  useCreatePersonListMutation,
  useUpdatePersonListMutation,
  useDeletePersonListMutation,
} = personListsApi;
